export default __webpack_public_path__ + "static/media/Upload.9ea2064e.svg";